const getters = {
  required: () => v => !!v || 'Esse campo deve ser preenchido.',
  email: () => v => /.+@.+\..+/.test(v) ? true : 'O e-mail deve ser válido.', // eslint-disable-line
  telephone: () => v => (v && v.length === 15) || 'Número invalido',
  fileRequired: () => v =>  v == null ? 'Esse campo deve ser preenchido' : true
}

export default getters;
